import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText, FormInput } from 'lucide-react';
const DOC_CONTRACT = 'https://mag-agregator.com/wp-content/uploads/2025/11/АД_МАГрегатор_СЗ_НПД-.pdf';
const DOC_FORM = 'https://forms.yandex.ru/cloud/67cae36c493639185512dcf4/';

const PRICE_ROWS = [
    { label: 'Студент МАГ (со второго года обучения)', price: 'до 1 950 ₽' },
    { label: 'Выпускник гештальт-школ без опыта и специалист с опытом до 2х лет*', price: 'до 2 600 ₽' },
    { label: 'Специалист с опытом от 2-х лет', price: 'до 3 900 ₽' },
    { label: 'Специалист с опытом от 3-х лет', price: 'до 4 550 ₽' },
    { label: 'Тренер МАГ', price: 'до 5 850 ₽' },
    { label: 'Специалист с опытом от 5 лет', price: 'до 5 850 ₽' },
    { label: 'Специалист с опытом от 7-ми лет', price: 'до 6 500 ₽' },
    {
        label: 'Специалист с опытом от 7-ми лет с сертификатами международных школ (GATLA, IFGT)',
        price: 'до 9 100 ₽'
    }
];


export default function TherapistsTermsContent({back = '/public/therapists', formUrl = DOC_FORM}) { return (<div className="therapists-terms-container">
                <Link to={back} className="back-link">
                    <ArrowLeft size={16} />
                    Назад к магрегатору
                </Link>

                <header className="terms-header">
                    <h1>Терапевтам и супервизорам</h1>
                    <p className="terms-lead">Условия сотрудничества</p>
                    <p className="terms-notice">
                        В данный момент к размещению на сервисе принимаем только студентов и выпускников МАГ
                    </p>
                </header>

                <div className="terms-sections">
                    <section className="terms-section">
                        <div className="terms-section-num" aria-hidden="true">1</div>
                        <div className="terms-section-body">
                            <h2>Заявка</h2>
                            <p>
                                Вы подаёте заявку через{' '}
                                <a href={formUrl} target="_blank" rel="noopener noreferrer">
                                    форму
                                </a>
                                , размещённую в разделе «Терапевтам (условия сотрудничества)».
                            </p>
                        </div>
                    </section>

                    <section className="terms-section">
                        <div className="terms-section-num" aria-hidden="true">2</div>
                        <div className="terms-section-body">
                            <h2>Размещение анкеты</h2>
                            <p>
                                После согласования заявки с администратором и подписания договора анкета размещается
                                на сервисе. Личное расписание вы настраиваете в кабинете терапевта в Магрегаторе.
                            </p>
                            <p className="terms-callout">
                                <span className="terms-callout-label">Важно</span>
                                Свой график вы настраиваете и обновляете самостоятельно.
                            </p>
                        </div>
                    </section>

                    <section className="terms-section">
                        <div className="terms-section-num" aria-hidden="true">3</div>
                        <div className="terms-section-body">
                            <h2>Стоимость сессии</h2>
                            <div className="terms-price-table">
                                {PRICE_ROWS.map((row) => (
                                    <div key={row.label} className="terms-price-row">
                                        <span className="terms-price-label">{row.label}</span>
                                        <span className="terms-price-value">{row.price}</span>
                                    </div>
                                ))}
                            </div>

                            <div className="terms-notes">
                                <p>
                                    *Опыт рассчитывается с даты выдачи специалисту сертификата. Если институт, который
                                    вы закончили, не сертифицирует специалистов — с даты, указанной в дипломе.
                                </p>
                                <p>
                                    *Студенты, которым нужны часы в зачётку, оплачивают сессии согласно ценам,
                                    указанным в ученическом договоре. Оплата производится в разделе{' '}
                                    <a
                                        href="https://mag-gestalt.ru/mag/educational-services-under-contract/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        «Оплата образовательных услуг по договору»
                                    </a>
                                    .
                                </p>
                            </div>

                            <p>
                                Стоимость сессии подлежит изменению в связи с увеличением опыта терапевта. Изменённая
                                стоимость применяется к новым клиентам, оформление правоотношений с которыми произошло
                                после изменения цены. Для повышения стоимости необходимо связаться с куратором сервиса.
                            </p>
                            <p>
                                Применение новой стоимости к уже существующим клиентам допускается при соблюдении
                                обоих условий:
                            </p>
                            <ul className="terms-bullets">
                                <li>
                                    период работы с клиентом равен одному году или превышает один год;
                                </li>
                                <li>
                                    терапевт уведомил клиента не позднее чем за <strong>3 месяца</strong> до применения
                                    новой стоимости.
                                </li>
                            </ul>
                        </div>
                    </section>

                    <section className="terms-section">
                        <div className="terms-section-num" aria-hidden="true">4</div>
                        <div className="terms-section-body">
                            <h2>Оплата и выплаты</h2>
                            <p>
                                Стоимость каждой сессии перечисляется клиентом{' '}
                                <strong>до её начала в личном кабинете</strong>. Терапевт самостоятельно контролирует оплату сессии.
                            </p>
                            <p>
                                Студенты-зачёточники МАГа оплачивают сессии через МАГ по образовательному договору
                                (вкладка «образовательные услуги по договору») на{' '}
                                <a
                                    href="https://mag-gestalt.ru/mag/payment/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    странице оплаты
                                </a>, а не через Магрегатор.
                            </p>
                            <p className="terms-callout">
                                <span className="terms-callout-label">Комиссия</span>
                                После удержания комиссии агрегатором (<strong>18%</strong>) средства перечисляются
                                терапевту через систему электронного документооборота «Консоль».
                            </p>
                            <p className="terms-callout terms-callout--warn">
                                <span className="terms-callout-label">Обязательно</span>
                                Налоговый статус терапевта — ИП, ИП на режиме НПД или самозанятый.
                            </p>
                            <ul className="terms-bullets">
                                <li>
                                    Выплаты — ежемесячно, не позднее <strong>05 числа</strong> следующего месяца.
                                </li>
                            </ul>
                        </div>
                    </section>

                    <section className="terms-section">
                        <div className="terms-section-num" aria-hidden="true">5</div>
                        <div className="terms-section-body">
                            <h2>Отчёт</h2>
                            <p>
                                Отчётный период закрывается 25-го числа каждого месяца, без подачи ведомости.
                                Все консультации после 25-го числа переносятся в выплату следующего периода.
                                При возникновении вопросов или трудностей можно обратиться к куратору сервиса
                                в чате через личный кабинет или на почту{' '}
                                <a href="mailto:magregator@mag-gestalt.ru">magregator@mag-gestalt.ru</a>.
                            </p>
                        </div>
                    </section>

                    <section className="terms-section">
                        <div className="terms-section-num" aria-hidden="true">6</div>
                        <div className="terms-section-body">
                            <h2>Этика</h2>
                            <p>Соблюдение Этического кодекса гештальт-терапевта.</p>
                        </div>
                    </section>
                </div>

                <div className="terms-actions">
                    <a
                        href={DOC_CONTRACT}
                        className="btn btn-secondary"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <FileText size={18} />
                        Договор
                    </a>
                    <a href={formUrl} className="btn btn-primary" target="_blank" rel="noopener noreferrer">
                        <FormInput size={18} />
                        Форма
                    </a>

                </div>
            </div>); }
